import React from 'react';
import './header.css'
import logo from '../../assets/img/logoAngiang.png'

function Header () {
  
        return (
            <div>
                     <header className="headerContainer">

    <div className="headerLeftSection">

      <div className="headerLogoWrapper">

        <div className="headerLogoCircle">
          <img
            className="headerLogoImage"
            src={logo}
            alt="logo"
          />
        </div>

        <div className="headerTitleWrapper">
          <span className="headerTitleTop">
            NỀN TẢNG QUẢN LÝ DỮ LIỆU
          </span>

          <span className="headerTitleBottom">
            KHU CÔNG NGHIỆP TỈNH AN GIANG
          </span>
        </div>

      </div>

      <div className="headerCenterSection">

        <button className="headerMenuButton">
          <i className="fa-solid fa-bars headerMenuIcon"></i>
        </button>

        <div className="headerDashboardText">
            
        <input className='form-control find-data'
        placeholder='Tìm kiếm chức năng dữ liệu...'
        />

        <i className="fa-solid fa-magnifying-glass icon-magnifying-glass"></i>
        </div>

      </div>

    </div>

    <div className="headerRightSection">

      <div className="headerDateWrapper">
        <i className="fa-regular fa-calendar headerDateIcon"></i>

        <span className="headerDateText">
          12/05/2026
        </span>
      </div>

      <div className="headerNotificationWrapper">
        <i className="fa-regular fa-bell headerNotificationIcon"></i>

        <div className="headerNotificationBadge">
          3
        </div>
      </div>

      <div className="headerHelpWrapper">
        <i className="fa-regular fa-circle-question headerHelpIcon"></i>
      </div>

      <div className="headerDivider"></div>

      <div className="headerProfileWrapper">

        <div className="headerAvatarCircle">
          <i className="fa-regular fa-user headerAvatarIcon"></i>
        </div>

        <div className="headerUserInfo">

          <span className="headerUserName">
            Nguyễn Văn A
          </span>

          <span className="headerUserRole">
            Quản trị hệ thống
          </span>

        </div>

        <div className="headerArrowWrapper">
          <i className="fa-solid fa-chevron-down headerArrowIcon"></i>
        </div>

      </div>

    </div>

  </header>
            </div>
        );
    }


export default Header;